// extracted by mini-css-extract-plugin
export default {"projectFrame":"ProjectEmbed_projectFrame__hQDS2"};